import React, { useState, memo } from 'react';
import ListItem from './ListItem';
import AxiosServices from '../../../services/AxiosServices';
import Singleton from '../../../core/singleton';
import { ErrorJumbotron } from '../../../ui/ErrorJumbotron';
import ModalOrder from './ModalOrder';
import Error from '../../../ui/Error';
import Loader from '../../../ui/Loader';

const List = props => {
    const { getTradByKey } = Singleton.getInstance();
    const [modalData, setModalData] = useState(null);
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    /** simply show the modal */
    const showListProductOfOrder = order => {
        setModalData(order);
    }
    /** when the status change (triggered by the btns in the modal) */
    const onStatusChange = (status, order) => {
        let { invoice_number } = order;
        let c = {
            "uuid": invoice_number,
            "status": status.toLowerCase()
        }
        let apply = () => {
            setStatus(invoice_number, c);
            setError(null);
            setModalData(null);
        }
        let isAProtectedStatus = Boolean(props.ordersWorkflow.protected_places && props.ordersWorkflow.protected_places.includes(order.status));
        if (isAProtectedStatus) {
            if (confirm("Are you sure you want to change the status of this order ?")) {
                apply();
            }
        } else {
            apply();
        }
    }
    const setStatus = (invoice_number, obj) => {
        setPending(true);
        AxiosServices.putOrderStatus(invoice_number, obj).then(() => {
            setPending(false);
            props.refresh();
        }).catch(error => {
            setPending(false);
            setError({ error: error, retry: () => setStatus(invoice_number, obj) });
            console.log(error.response);
        })
    }
    const FullList = () => {
        return <div className="row">
            {
                (pending) &&
                <Loader />
            }
            {
                (modalData !== null) &&
                <ModalOrder
                    modalData={modalData}
                    setModalData={value => setModalData(value)}
                    onClose={() => setModalData(null)}
                    onStatusChange={(status, order) => onStatusChange(status, order)}
                    ordersWorkflow={props.ordersWorkflow} />
            }
            {
                props.displayedOrders.map(
                    (order, index) => <ListItem
                        showListProductOfOrder={order => showListProductOfOrder(order)}
                        ordersWorkflow={props.ordersWorkflow}
                        onStatusChange={(status, order) => onStatusChange(status, order)}
                        key={index}
                        order={order} />
                )
            }
            {
                (error !== null) &&
                <Error response={error}>
                    <h1>{error.error.name} <i className="fas fa-bug"></i></h1>
                    <p><strong>{error.error.response.data.msg}</strong></p>
                    <button
                        onClick={() => error.retry()}
                        className="btn btn-primary">{getTradByKey('try_again')} <i className="fas fa-history"></i>
                    </button>
                </Error>
            }
        </div>;
    }
    return (props.displayedOrders.length > 0) ? <FullList /> : <ErrorJumbotron message={getTradByKey('nothing_to_see')} />

}
export default memo(List)